import { useQuery } from '@tanstack/react-query';

import { fetchPerformanceOverview } from '@/entities/insight/index';
import type { PublicFilter } from '../../shared/public-filter/use-public-filter';

export function usePerformanceOverview(params: {
  queryId: string;
  startDate: string;
  endDate: string;
  enabled: boolean;
  publicFilter: PublicFilter;
}) {
  return useQuery({
    queryKey: [
      'performance-overview',
      params.queryId,
      params.startDate,
      params.endDate,
      params.publicFilter,
    ],
    queryFn: ({ signal }) => fetchPerformanceOverview(params, signal),
    placeholderData: (previousData) => previousData,
    enabled: params.enabled,
  });
}
